import ReviewAnswer from './ReviewAnswer';

export default ReviewAnswer;
